// Modal da câmera do atendimento (abre pelo "+" do MessageInput), no padrão
// Aeros Dark: casca AerosDialog no lugar do react-modal com estilo inline.
// Comportamento igual ao anterior — a foto tirada vira um Blob e já é
// devolvida ao MessageInput, que abre a pré-visualização de envio.
import React, { useEffect, useState } from 'react';
import Camera, { FACING_MODES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import { makeStyles } from '@material-ui/core/styles';

import AerosDialog from '../AerosDialog';
import { i18n } from '../../translate/i18n';

const useStyles = makeStyles((theme) => ({
  stage: {
    backgroundColor: "#000",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 320,
    "& .react-html5-camera-photo": { width: '100%' },
    "& .react-html5-camera-photo > video": { width: '100%', display: 'block' },
  },
}));

const ModalCamera = ({ isOpen, onRequestClose, onCapture }) => {
  const classes = useStyles();
  const [capturedImage, setCapturedImage] = useState(null);

  const handleTakePhoto = (dataUri) => {
    setCapturedImage(dataUri);
  };

  // Converte a imagem capturada em Blob e devolve ao chamador. Antes isso
  // rodava dentro do JSX (`{capturedImage && handleConfirm()}`), ou seja,
  // efeito colateral durante a renderização.
  useEffect(() => {
    if (!capturedImage) return;
    fetch(capturedImage)
      .then((res) => res.blob())
      .then((blob) => {
        onCapture(blob);
        setCapturedImage(null);
        onRequestClose();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [capturedImage]);

  return (
    <AerosDialog
      open={isOpen}
      onClose={onRequestClose}
      width={760}
      title={i18n.t("aeros.camera.title")}
      subtitle={i18n.t("aeros.camera.subtitle")}
      flushBody
    >
      <div className={classes.stage}>
        <Camera
          onTakePhoto={handleTakePhoto}
          idealFacingMode={FACING_MODES.ENVIRONMENT}
          isImageMirror={false}
        />
      </div>
    </AerosDialog>
  );
};

export default ModalCamera;
